<template>
	<Modal v-bind="$attrs" v-on="$listeners" @closed="closed">
		<div class="rounded overflow-auto w-fit">
			<div class="text-blue-700 font-bold mb-1">見積一覧にてテストデータ表示設定</div>
			<div class="text-blue-700 text-sm mb-1">※受託営業部かつ「表示」設定されている人のみ全てのテストデータが表示されます。</div>
			<div class="text-blue-700 text-sm mb-1">（それ以外は、本人が作ったテストデータのみ表示）</div>
			<div class="text-blue-700 text-sm mb-5">※管理者権限者はテストデータが表示されます。</div>
			<table class="w-full">
				<thead class="">
					<tr class="">
						<th v-for="(c, i) in columns" :key="'m' + i" class="text-center pl-3 pr-3 pt-1 pb-1 whitespace-pre-line">{{ c }}</th>
					</tr>
				</thead>
				<tr v-for="(row, i) in list" :key="'mr' + i">
					<!-- 名前 -->
					<td class="pr-3 pb-1">{{ row.userName }}</td>

					<!-- 非表示固定 -->
					<td class="text-right px-3 pb-1 flex w-fit">
						<div class="font-bold text-white rounded cursor-pointer py-2 w-20 text-center mr-1" :class="row.estimateTestAuth?'bg-indigo-800':'bg-gray-300'" @click="changeAuth(row, true)">
							表示
						</div>
						<div class="font-bold text-white rounded cursor-pointer py-2 w-20 text-center" :class="!row.estimateTestAuth?'bg-indigo-800':'bg-gray-300'" @click="changeAuth(row, false)">
							非表示
						</div>
					</td>
				</tr>
			</table>
			
			<PrimaryButton
				text="保存"
				class="m-3 save-btn"
				:class="!boss?'bg-gray-300':''"
				:disabled="!boss"
				v-tooltip="'受託営業部の上司のみ保存できます'"
				@click="save()"
			>
			</PrimaryButton>
		</div>
		<div class="text-transparent">{{reload}}</div>
	</Modal>
</template>

<script>
import Modal from '@components/Modal.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import * as backend from '@libs/backend'
import * as utils from '@libs/utils'
import * as logManager from '@managers/logManager'

export default {
	components: {
		Modal,
		PrimaryButton,
	},

	props: ['open'],

	data() {
		return {
			// カラム
			columns: [
				'名前',
				'表示'
			],
			// 表示データ
			list: [],
			reload: 0
		}
	},

	computed: {
		boss() {
      let b = this.$store.getters.loginUserData.boss
			if (b) {
				// 所属部署を取得
				const dep = this.$store.getters.dualPosition
				if (dep && dep.length) {
					// 受託か確認
					const isDep = dep.find((d) => {
						return (d.departmentName.indexOf('受託営業') > -1)
					})
					if (isDep && isDep.departmentName) {
						return true
					}
				}
			}
			// 管理者権限の場合
			let auth2 = this.$store.getters.auth
			if (auth2 && auth2.adminAuth) {
				return true
			}
			return false
		}
	},

	watch: {
		open() {
			this.getList()
		}
	},

	methods: {
		/**
		 * モーダルclose
		 */
		closed() {
			this.list = []
		},

		/**
		 * データ取得
		 */
		async getList() {
			if (!this.open) {
				return
			}
			this.list = []
			let result = await backend.searchData('user/getUserList', { day: utils.getToday(), departmentId: 'd1444' })
			if (result.data.data) {
				const res = result.data.data
				this.list = res.filter((l) => {
					return l.userName != '未定' && !l.adminAuth
				})
			}
		},

		/**
		 * 権限変更イベント
		 * @param row 対象行 
		 * @param val 値
		 */
		changeAuth(row, val) {
			row.estimateTestAuth = val
			this.reload++
		},

		/**
		 * 保存
		 */
		async save() {
			let res = []
			for (let i = 0; i < this.list.length; i++) {
				const e = this.list[i]
				if (e.estimateTestAuth) {
					res.push(e.userName)
				}
			}
			await backend.postData('auth/saveEstimateTestAuth', { list: this.list, insertUser: this.$store.getters.user.id})
			logManager.recording(this, logManager.Loglevel.INFO, '見積りテストデータ権限', '更新', `見積りテストデータ閲覧権限を更新しました。\r\n${res.join('、')}に権限を与えました。`)
			this.$emit('closed')
			this.closed()
		}
	}
}
</script>
<style scoped>
.save-btn {
	width: -webkit-fill-available;
}
</style>